import type { SiteRuntimePricing } from '@/site-runtime/types';

export function resolveSiteRuntimeCheckoutIntentDisplay(
  pricing: SiteRuntimePricing,
  checkoutIntentKey: string
) {
  const intent = pricing.checkoutIntents.find(
    (candidate) => candidate.intentKey === checkoutIntentKey
  );
  if (!intent) {
    throw new Error(
      `Published Pricing checkout intent ${checkoutIntentKey} was not found.`
    );
  }

  if (intent.scene === 'subscription') {
    if (!intent.allowedPlanKeys.includes(intent.defaultPlanKey)) {
      throw new Error(
        `Published Pricing checkout intent ${intent.intentKey} has an invalid default plan.`
      );
    }
    const plan = pricing.plans.find(
      (candidate) => candidate.planKey === intent.defaultPlanKey
    );
    if (!plan) {
      throw new Error(
        `Published Pricing checkout intent ${intent.intentKey} references a missing plan.`
      );
    }
    return {
      scene: intent.scene,
      checkoutIntentKey: intent.intentKey,
      checkoutSurface: intent.checkoutSurface,
      title: plan.planName,
      description: plan.planDescription,
      buttonLabel: plan.buttonLabel,
    };
  }

  if (!intent.allowedPackageKeys.includes(intent.defaultPackageKey)) {
    throw new Error(
      `Published Pricing checkout intent ${intent.intentKey} has an invalid default package.`
    );
  }
  const creditPackage = pricing.creditPackages.find(
    (candidate) => candidate.packageKey === intent.defaultPackageKey
  );
  if (!creditPackage) {
    throw new Error(
      `Published Pricing checkout intent ${intent.intentKey} references a missing package.`
    );
  }
  return {
    scene: intent.scene,
    checkoutIntentKey: intent.intentKey,
    checkoutSurface: intent.checkoutSurface,
    title: creditPackage.packageName,
    description: creditPackage.packageDescription,
    buttonLabel: creditPackage.buttonLabel,
  };
}
